import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { OperationModeMenu } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  var anchorEl = null
  if (state.operationModeMenu[ownProps.bid] && state.operationModeMenu[ownProps.bid].anchorEl) {
    anchorEl = state.operationModeMenu[ownProps.bid].anchorEl
  }
  return ({
    anchorEl
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClickListItem: (event) => {
      dispatch(actions.operationModeMenu.open(ownProps.bid, event.currentTarget))
    },
    handleMenuItemClick: (event, selectedIndex) => {
      ownProps.onSelected(ownProps.bid, selectedIndex)
      dispatch(actions.operationModeMenu.close(ownProps.bid))
    },
    handleClose: () => {
      dispatch(actions.operationModeMenu.close(ownProps.bid))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OperationModeMenu)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/OperationModeMenu.js